/* eslint-disable no-unused-vars */
import { Grid, Typography, CircularProgress } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { SyncUtils } from "../../utils/SyncUtils";
import PAutoCompleteMultiSelect from "./../../components/pos/PAutoCompleteMultiSelect";

export default function CategoryCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("New Category");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);
  const [parentId, setParentId] = useState("");
  const [level, setLevel] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [catCode, setCatcode] = useState("");
  const [catCodeError, setCatcodeError] = useState("");
  const [deliItem, setDeliitem] = useState(false);
  const [deliItemError, setDeliitemError] = useState("");
  const [groupCode, setGroupcode] = useState("");
  const [groupCodeError, setGroupcodeError] = useState("");
  const [promotionOptions, setPromotionOptions] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.deptChild = {
    showCategoryCrudWindow: showCategoryCrudWindow,
  };

  useEffect(() => {
    getPromotions();
  }, []);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);

  useEffect(() => {
    if (liveValidation && deliItem && groupCode === "")
      setGroupcodeError(translate("Group code is Required"));
    else setGroupcodeError("");
  }, [groupCode]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function getPromotions() {
    const result = await API.get("/api/v1/find/all/promotions");
    let promotionOptions = [];
    for (let promotion of result.data) {
      if (promotion.ruleConfigList[0].ruleType.code != "PRODUCT_LEVEL_PRICING")
        promotionOptions.push({
          label: promotion.policyName,
          value: promotion,
        });
    }
    console.log(promotionOptions);
    setPromotionOptions(promotionOptions);
  }

  /*level: the level of parent item*/
  function showCategoryCrudWindow(catId, level, catMode) {
    setMode(catMode);
    setWindowTitile(
      (catMode == "create" ? "Add " : "Edit ") +
      (level == null
        ? "Department"
        : level == 0
          ? "Sub Department"
          : level == 1
            ? "Category"
            : "Sub Category")
    );
    setLiveValidation(false);
    setOpenWindow(true);
    if (catMode == "edit") {
      populateCategory(catId);
    } else if (catMode == "view") {
      populateCategory(catId);
    } else if (catMode == "create") {
      if (level == null) {
        setParentId(null);
        setLevel(0);
      } else {
        setParentId(catId);
        setLevel(Number(level) + 1);
      }
    }
    resetFields();
  }
  async function populateCategory(id) {
    {
      try {
        let { data } = await API.get("/api/v1/category/" + id);
        console.log("data fetched: " + JSON.stringify(data));
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Category data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setCatcode(bean.catCode);
    setDeliitem(bean.deliItem);
    setGroupcode(bean.groupCode);
    setLevel(bean.level);
    setParentId(bean.parentId);

    let promotionList = [];
    if (
      bean.promotionBeanList != null &&
      bean.promotionBeanList != undefined &&
      bean.promotionBeanList != ""
    ) {
      for (let k = 0; k < bean.promotionBeanList.length; k++) {
        promotionList.push(getPromotionById(bean.promotionBeanList[k].id));
      }
    }
    setPromotions(promotionList);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }
  function getPromotionById(promotionId) {
    for (let option of promotionOptions) {
      if (option.value.id == promotionId) return option;
    }
  }

  function resetFields() {
    setName("");
    setNameError("");
    setCatcode("AUTO");
    setCatcodeError("");
    setDeliitem("");
    setDeliitemError("");
    setGroupcode("");
    setGroupcodeError("");

    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message:
        translate("Are you sure to delete category") +
        ":" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/category/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Category") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Category"));
        }
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/category", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        if (props.onRefresh != null && props.onRefresh != undefined)
          props.onRefresh();
        if (props.selectCategory != null && props.selectCategory != undefined)
          props.selectCategory(result.data);
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Category"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "catCode") {
        setCatcodeError(obj.message);
      }
      if (obj.field === "deliItem") {
        setDeliitemError(obj.message);
      }
      if (obj.field === "groupCode") {
        setGroupcodeError(obj.message);
      }
      if (obj.field === "product") {
        setGroupcodeError(obj.message);
      }
      if (obj.field === "parentId") {
        setGroupcodeError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log("current parent ID: " + parentId);
    saveObject["name"] = name;
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    saveObject["catCode"] = catCode;
    saveObject["deliItem"] = deliItem;
    saveObject["parentId"] = parentId;
    saveObject["level"] = level;
    saveObject["groupCode"] = groupCode;
    let promotionIds = [];
    for (let promotionItem of promotions) {
      promotionIds.push(promotionItem.value.id);
    }
    saveObject["promotionIds"] = promotionIds;
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError("Name is Required");
      flag = false;
    }
    /* if (!catCode || catCode === "") {
      setCatcodeError("Catcode is Required");
      flag = false;
    }*/
    if (deliItem && (!groupCode || groupCode === "")) {
      setGroupcodeError(translate("Group code is Required"));
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={20}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Category Code")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={catCode}
                    InputProps={{ readOnly: catCode == "AUTO" ? true : false }}
                    error={catCodeError}
                    onChange={(e) => setCatcode(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Name")}</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {level == 0 && (
                <tr>
                  <td></td>
                  <td>
                    <PCheck
                      onChange={(value) => setDeliitem(value)}
                      checked={deliItem}
                      label={translate("Is Deli Item")}
                    ></PCheck>
                  </td>
                </tr>
              )}
              {deliItem ? (
                <tr>
                  <td>
                    <Typography variant="body1">
                      {translate("Group code")}
                    </Typography>
                  </td>
                  <td>
                    <PText
                      value={groupCode}
                      error={groupCodeError}
                      onChange={(e) => setGroupcode(e.target.value)}
                    ></PText>
                  </td>
                </tr>
              ) : null}
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Promotion")}
                  </Typography>
                </td>
                <td>
                  <PAutoCompleteMultiSelect
                    options={promotionOptions}
                    placeholder={translate("Select...")}
                    value={promotions}
                    onChange={(e, value) => {
                      setPromotions(value);
                    }}
                  />
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    if (mode === "create") {
      if (catCode != "AUTO") return true;
    }
    if (mode === "edit") {
      if (catCode !== origObject.catCode) return true;
    }
    if (mode === "create") {
      if (deliItem) return true;
    }
    if (mode === "edit") {
      if (deliItem !== origObject.deliItem) return true;
    }
    if (mode === "create") {
      if (groupCode || groupCode != "") return true;
    }
    if (mode === "edit") {
      if (groupCode !== origObject.groupCode) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"xs"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          hideSave={
            (!props.context.privileges.category_edit &&
              props.context.privileges.category_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          onDelete={props.context.privileges.category_delete ? onDelete : false}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
